import {Box} from '@mui/material';
import appLogoDefault from 'assets/images/YS-logo-white.png';
import appLogo from 'assets/images/YS-logo.png';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

const AppLogo = ({variant, isDarkBg}) => {
  const isLarge = variant === 'large';
  const containerHeight = isLarge ? {xs: 70, sm: 80, md: 95} : {xs: 54, sm: 75};
  const imgHeight = isLarge ? {xs: 50, sm: 60, md: 70} : {xs: 40, sm: 55};
  const imageSrc = isDarkBg ? appLogoDefault : appLogo;

  return (
    <Box
      sx={{
        height: containerHeight,
        display: 'flex',
        flexDirection: 'row',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease',
        backgroundColor: 'transparent',
      }}
      className='app-logo'
    >
      <Link to='/' style={{display: 'flex', alignItems: 'center'}}>
        <Box
          component='img'
          sx={{
            height: imgHeight,
            width: 'auto',
            objectFit: 'contain',
            display: 'block',
            imageRendering: '-webkit-optimize-contrast',
            '@media low-resolution': {
              imageRendering: 'crisp-edges',
            },
            filter: isDarkBg ? 'brightness(1.1) contrast(1.1)' : 'none',
          }}
          alt='logic-grid'
          src={imageSrc}
        />
      </Link>
    </Box>
  );
};

AppLogo.propTypes = {
  variant: PropTypes.oneOf(['default', 'large']),
  isDarkBg: PropTypes.bool,
};

AppLogo.defaultProps = {
  variant: 'default',
  isDarkBg: true,
};

export default AppLogo;
